module.exports = __webpack_public_path__ + "static/media/menuWorkflow.e9d4fcfc.svg";